export default "__VITE_ASSET__4f3a072f__"